var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-footer',{staticClass:"me-area"},[_c('div',{staticClass:"me-footer"},[_c('h5',[_vm._v("Copyright © 2023-2024  \n      "),_c('strong',[_c('router-link',{staticClass:"me-login-design-color",attrs:{"to":"/"}},[_vm._v("Zainyu 版权所有")])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a260e1ba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BaseFooter.vue
// module id = null
// module chunks = 